import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[appTemplateRef]'
})
export class TemplateRefDirective {
  @Input('appTemplateRef') name!: string;
  constructor(public templateRef: TemplateRef<unknown>) { }
}
